// Yiddish translations
export const yi: Record<string, string> = {
  'menu.dashboard': 'קאָנטראָל טאַוול',
  'menu.customers': 'קונים',
  'menu.products': 'פּראָדוקטן',
  'menu.users': 'באַניצער',
  'menu.settings': 'באַשטעטיקונגען',
  'menu.logout': 'אַרויסגיין',
  'dashboard.title': 'קאָנטראָל טאַוול',
  'dashboard.newOrder': 'נייַע סדר',
  'order.title': 'נייַע סדר',
  'order.customer': 'קוילן',
  'order.products': 'פּראָדוקטן',
  'order.total': 'גאַנץ',
  'users.title': 'באַניצער',
  'users.name': 'נאָמען',
  'users.email': 'בליצפּאָסט',
  'common.yes': 'יאָ',
  'common.no': 'ניין',
  'common.cancel': 'באָטל מאַכן',
  'common.save': 'היט',
  'common.search': 'זוכן',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'אַרייַן',
  'login.welcome': 'ברוכים הבאים, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'בליצפּאָסט',
  'signup.phone': 'טעלעפאָן',
  'menu.reportsAndAccounting': 'באַריכטן און חשבונות',
  'menu.systemAndCommunication': 'סיסטעם און קאָמוניקאַציע',
};